exports = module.exports = require("./../../../node_modules/.0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".vw-nav-item-content{display:inline-block;position:relative}", "", {"version":3,"sources":["/./src/components/nav/nav-item.vue"],"names":[],"mappings":"AACA,qBAAqB,qBAAqB,iBAAiB,CAC1D","file":"nav-item.vue","sourcesContent":["\n.vw-nav-item-content{display:inline-block;position:relative\n}"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.25.0@css-loader?sourceMap!./~/.10.0.2@vue-loader/lib/style-rewriter.js?id=data-v-10eecdde!./~/.2.2.3@less-loader?sourceMap!./~/.10.0.2@vue-loader/lib/selector.js?type=styles&index=0!./src/components/nav/nav-item.vue
// module id = 68
// module chunks = 0